<template>
	<label>
		<em class="lt_text">State</em>
		<span class="int_type_no_border mgr_5"> <CodeSelect :width="100" :codeWidth="120" :showDesc="false" :codes="filteredStates" v-model="state" @input="updateValue" /> </span>
	</label>
</template>

<script>
import CodeSelect from '@/components/common/CodeSelect';
import { apiSelectStateList } from '@/api/search/search';

export default {
	name: 'StateSelect',
	props: {
		value: {
			type: String,
		},
		country: {
			type: String,
		},
	},
	data: function() {
		return {
			states: [],
			state: '',
		};
	},
	watch: {
		value: {
			immediate: true,
			handler() {
				this.state = this.value;
			},
		},
	},
	computed: {
		user: function() {
			return this.$session.get('user');
		},
		filteredStates: function() {
			if ((!this.country || this.country == '') && this.user.company_id == 'newjigu') return this.states;

			const vm = this;
			const fStates = this.states.filter(s => s.country === vm.country);
			if (fStates.length === 0) vm.state = null;
			return fStates;
		},
	},
	methods: {
		async selectData() {
			const { data } = await apiSelectStateList();
			this.states = data.value;
		},
		updateValue() {
			this.$emit('input', this.state);
		},
		reset() {
			this.state = '';
			this.updateValue();
		},
	},
	components: {
		CodeSelect,
	},
	mounted() {
		this.selectData();
	},
};
</script>

<style scoped></style>
